export default __webpack_public_path__ + "static/media/login-page-logo-dark.aebeae48.svg";